import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SiTimezoneServiceService } from './si-timezone-service.service';
import { SiDataService } from '../../services/si-data.service';
import timezoneList from '../../../timezone.json';
import { HttpClient } from '@angular/common/http';
import * as jstz from 'jstz';
declare var $;
interface Timezone {
  name: string;
  code: string;
  abbr: string;
}

@Component({
  selector: 'si-timezone',
  providers: [HttpClient],
  templateUrl: './si-timezone.component.html',
  styleUrls: ['./si-timezone.component.scss']
})
export class SiTimezoneComponent implements OnInit {
  // @Output() onFilter: EventEmitter<any> = new EventEmitter();

  timezones: Timezone[];
  selectedTimezone: Timezone = { name: '', code: '', abbr: '' };
  isSave: boolean = false;
  saveAlert: boolean = false;
  isAutoRefresh: boolean;

  constructor(private siTimeZone: SiTimezoneServiceService, private siDataService: SiDataService) { }

  ngOnInit() {
    this.siTimeZone.getUserPreference().subscribe(
      (response) => {
        const timezoneDropdownData = [];
        timezoneList.forEach((d) => {
          timezoneDropdownData.push({ name: d.text, code: d.utc[0], abbr: d.abbr });
        });
        this.timezones = timezoneDropdownData;

        if (response.length !== 0) {
          const abbrData = timezoneList.find((element): any => {
            return element.text.includes(response[0]['timezone']);
          });
          this.selectedTimezone = { name: abbrData.text, code: abbrData.utc[0], abbr: abbrData.abbr };
          this.isAutoRefresh = response[0]['auto_refresh'];
          const forUpdateLatestTimeZone = { name: abbrData.text, code: abbrData.utc[0], abbr: abbrData.abbr };
          this.siDataService.filter(forUpdateLatestTimeZone, response[0]['auto_refresh']);

        } else {
          const timezone = jstz.determine();
          const localTimezoneName = timezone.name();
          const abbrData = timezoneList.filter((element): any => {
            const a = element.utc.indexOf(localTimezoneName);
            return a > -1;
          })[0];
          this.selectedTimezone = { name: abbrData.text, code: abbrData.utc[0], abbr: abbrData.abbr };
          this.isAutoRefresh = true;
          this.siDataService.filter(this.selectedTimezone, true);
        }

      }, (error) => {
        console.log(error);
      });
  }

  savePreference(timezone, refresh_mode) {
    this.isSave = true;
    this.siTimeZone.savePreferences(timezone, refresh_mode).subscribe(
      (response) => {
        this.siDataService.filter(timezone, refresh_mode);
        this.saveAlert = true;
        this.isSave = false;
        setTimeout(() => { this.saveAlert = false; $('#userpreference').modal('hide'); }, 2000);
      }, (error) => {
        console.log(error);
      });
  }

}
